export const GET_FAMILY_CLAN_LEVEL = "GET_FAMILY_CLAN_LEVEL";
export const CREATE_NEW_FAMILY_CLAN_LEVEL = "CREATE_NEW_FAMILY_CLAN_LEVEL";
export const EDIT_FAMILY_CLAN_LEVEL = "EDIT_FAMILY_CLAN_LEVEL";
export const DELETE_FAMILY_CLAN_LEVEL = "DELETE_FAMILY_CLAN_LEVEL";

export const OPEN_FAMILY_CLAN_LEVEL_DIALOG = "OPEN_FAMILY_CLAN_LEVEL_DIALOG";
export const CLOSE_FAMILY_CLAN_LEVEL_DIALOG = "CLOSE_FAMILY_CLAN_LEVEL_DIALOG";
